import { UserRole } from '../enums/user-role.enum';

/**
 * Maps risk factor keys to the roles allowed to view/edit that category.
 * Mirrors the backend's RISK_FACTOR_ROLE_MAP (customer/views.py) — every
 * category maps to the same 5 roles today, but this stays per-key on
 * purpose so differentiating one category later is a one-line change here,
 * not a re-architecture.
 */
export const DEFAULT_RISK_FACTOR_ROLES: (keyof typeof UserRole)[] = ['AD', 'MA', 'AN', 'AU', 'SA'];

export const RISK_FACTOR_ROLES: Record<string, (keyof typeof UserRole)[]> = {
  actingownaccount: DEFAULT_RISK_FACTOR_ROLES,
  countryofbirth: DEFAULT_RISK_FACTOR_ROLES,
  countryofcitizenship: DEFAULT_RISK_FACTOR_ROLES,
  countryofresidence: DEFAULT_RISK_FACTOR_ROLES,
  expectedannualinvestment: DEFAULT_RISK_FACTOR_ROLES,
  occupation: DEFAULT_RISK_FACTOR_ROLES,
  pep: DEFAULT_RISK_FACTOR_ROLES,
  purposeofaccount: DEFAULT_RISK_FACTOR_ROLES,
  sanctions: DEFAULT_RISK_FACTOR_ROLES,
  sourceoffunds: DEFAULT_RISK_FACTOR_ROLES,
  watchlist: DEFAULT_RISK_FACTOR_ROLES
};

/**
 * A lookup_key with no explicit entry (e.g. a newly self-service-created
 * custom factor) defaults to the standard viewer roles rather than being
 * invisible to everyone — mirrors the backend's equivalent fallback in
 * risks/views.py::visible_risk_factors.
 */
export function getRiskFactorRoles(key: string): (keyof typeof UserRole)[] {
  return RISK_FACTOR_ROLES[key.toLowerCase()] ?? DEFAULT_RISK_FACTOR_ROLES;
}
